import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../../shared/auth/auth-guard.service';
import { AllOrdersComponent } from './allorders.component';



const routes: Routes = [
  {
    path: '',
     component: AllOrdersComponent,
    data: {
      title: 'orderlist'
    },    
    canActivate: [AuthGuard] 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AllOrdersRoutingModule { }